import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from "@angular/forms";
import { NgbTimeStruct, NgbTimepickerModule } from "@ng-bootstrap/ng-bootstrap";
import { from } from "rxjs";

@Component({
  selector: 'app-time-picker',
  standalone: true,
  imports: [
    NgbTimepickerModule,
    FormsModule
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TimePickerComponent),
      multi: true
    }
  ],
  templateUrl: './time-picker.component.html',
  styleUrls: ['./time-picker.component.scss']
})
export class TimePickerComponent implements ControlValueAccessor {

  time!: string | NgbTimeStruct | null;
  onChange!: (value: any) => void;
  onTouched!: () => void;
  disabled: boolean = false;
  private pad = (i: number): string => (i < 10 ? `0${i}` : `${i}`);

  writeValue(time: any): void {
    if (time !== undefined) {
      this.time = this.fromModel(time);
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }


  private fromModel(value: string | null): NgbTimeStruct | null {
    if (!value) {
      return null;
    }
    const split = value.split(':');
    return {
      hour: parseInt(split[0], 10),
      minute: parseInt(split[1], 10),
      second: parseInt(split[2], 10),
    };
  }

  //  timepicker uses a custom Time adapter that lets you use your own model implementation {hour,minute,seconds} => 00:00:00
  private toModel(time: NgbTimeStruct | null): string | null {
    return time != null ? `${this.pad(time.hour)}:${this.pad(time.minute)}:${this.pad(time.second)}` : null;
  }

  setValue() {
    const value: any = this.time;
    this.onChange(this.toModel(value));
    this.onTouched()
  }



}
